import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';

const Analytics = () => {
  const location = useLocation();

  useEffect(() => {
    let environment = process.env.REACT_APP_MODE??"";
    if(environment === "production"){
      var userData = localStorage.getItem('userData');
      var uName = localStorage.getItem('uName');
      ReactGA.set({ user_id: (userData?userData:null) }); 

      ReactGA.send({
        js: new Date(), 
        hitType: 'pageview', 
        page: window.location.pathname,
        //page_path: window.location.pathname,
        //user_id: userData?userData:null,
      });
    }
  }, [location]);

  return null;
};

export default Analytics;
